import { Description, AllInbox, AccountBox, DirectionsBoat, People, PieChart, ViewModule } from '@mui/icons-material';

export const menuObject = [
    {
        "menuLabel": "Dashboard",
        "menuDisplay": "Dashboard",
        "menuIcon": <PieChart />,
        "tableName": "DashBoard",
        "menuUrl": "dashboard"
    },
    {
        "menuLabel": "Accounting",
        "menuIcon": <People />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "UserConfig",
                "subMenuDisplay": "UserConfig",
                "subMenuOpen": false,
                "tableName": "user config",
                "subMenuUrl": "go/UserConfig",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "RoleConfig",
                "subMenuDisplay": "RoleConfig",
                "subMenuOpen": false,
                "tableName": "role config",
                "subMenuUrl": "go/RoleConfig",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "UsersGroups",
                "subMenuDisplay": "UsersGroups",
                "subMenuOpen": false,
                "tableName": "usersGroups",
                "subMenuUrl": "go/usersGroupsList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Company",
                "subMenuDisplay": "Company",
                "subMenuOpen": false,
                "tableName": "company",
                "subMenuUrl": "master/company",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Entities",
                "subMenuDisplay": "Entities",
                "subMenuOpen": false,
                "tableName": "Account",
                "subMenuUrl": "go/entities",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "LumpSum",
                "subMenuDisplay": "LumpSum",
                "subMenuOpen": false,
                "tableName": "LumpSum",
                "subMenuUrl": "master/lumpSumList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Quotes",
                "subMenuDisplay": "Quotes",
                "subMenuOpen": false,
                "tableName": "Quote",
                "subMenuUrl": "go/quoteList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveQuotes",
                "subMenuDisplay": "ApproveQuotes",
                "subMenuOpen": false,
                "tableName": "Quote",
                "subMenuUrl": "go/approveQuoteList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Quote Requests",
                "subMenuDisplay": "Quote Requests",
                "subMenuOpen": false,
                "tableName": "QuoteRequest",
                "subMenuUrl": "go/quoteList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ServiceTypes",
                "subMenuDisplay": "ServiceTypes",
                "subMenuOpen": false,
                "tableName": "Quote",
                "subMenuUrl": "go/serviceTypeList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ChargeRules",
                "subMenuDisplay": "ChargeRules",
                "subMenuOpen": false,
                "tableName": "ChargeRule",
                "subMenuUrl": "go/chargeRules",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "TransportClauses",
                "subMenuDisplay": "Transport Clauses",
                "subMenuOpen": false,
                "tableName": "TransportClause",
                "subMenuUrl": "go/transportClauses",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Locations",
                "subMenuDisplay": "Locations",
                "subMenuOpen": false,
                "tableName": "location",
                "subMenuUrl": "go/locationList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Commodities",
                "subMenuDisplay": "Commodities",
                "subMenuOpen": false,
                "tableName": "Commodity",
                "subMenuUrl": "go/commodityList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "DangerousGoods",
                "subMenuDisplay": "DangerousGoods",
                "subMenuOpen": false,
                "tableName": "dangerous goods",
                "subMenuUrl": "go/dangerousGoodsList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Currencies",
                "subMenuDisplay": "Currencies",
                "subMenuOpen": false,
                "tableName": "currency",
                "subMenuUrl": "go/currencyList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Exchange",
                "subMenuDisplay": "Exchange",
                "subMenuOpen": false,
                "tableName": "exchange",
                "subMenuUrl": "go/exchangeList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Shipments",
                "subMenuDisplay": "Shipments",
                "subMenuOpen": false,
                "tableName": "shipment",
                "subMenuUrl": "go/shipmentList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ShipmentCharges",
                "subMenuDisplay": "Shipment Charges",
                "subMenuOpen": false,
                "tableName": "shipmentCharges",
                "subMenuUrl": "go/shipmentChargesList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ShippingConditions",
                "subMenuDisplay": "ShippingConditions",
                "subMenuOpen": false,
                "tableName": "shippingcondition",
                "subMenuUrl": "go/shippingConditionList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Incoterms",
                "subMenuDisplay": "Incoterms",
                "subMenuOpen": false,
                "tableName": "incoterms",
                "subMenuUrl": "go/incotermsList",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "Billing",
        "menuIcon": <Description />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Invoices",
                "subMenuDisplay": "Invoices",
                "subMenuOpen": false,
                "tableName": "Invoice",
                "subMenuUrl": "go/invoiceList",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "Shipping",
        "menuIcon": <DirectionsBoat />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Trade",
                "subMenuDisplay": "Trade",
                "subMenuOpen": false,
                "tableName": "Trade",
                "subMenuUrl": "go/tradeList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Transports",
                "subMenuDisplay": "Transports",
                "subMenuOpen": false,
                "tableName": "Transports",
                "subMenuUrl": "go/transportList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Vessel",
                "subMenuDisplay": "Vessel",
                "subMenuOpen": false,
                "tableName": "Vessel",
                "subMenuUrl": "master/vessel",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Voyages",
                "subMenuDisplay": "Voyages",
                "subMenuOpen": false,
                "tableName": "Voyages",
                "subMenuUrl": "go/voyages",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Bookings",
                "subMenuDisplay": "Bookings",
                "subMenuOpen": false,
                "tableName": "Bookings",
                "subMenuUrl": "go/Bookings",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Booking Equipment",
                "subMenuDisplay": "Booking Equipment",
                "subMenuOpen": false,
                "tableName": "Booking Equipment",
                "subMenuUrl": "go/bookingEquipment",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveBooking",
                "subMenuDisplay": "ApproveBooking",
                "subMenuOpen": false,
                "tableName": "Approve Booking",
                "subMenuUrl": "go/approveBookingList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "BL's",
                "subMenuDisplay": "BL's",
                "subMenuOpen": false,
                "tableName": "BLs",
                "subMenuUrl": "go/BLs",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "ApproveBL",
                "subMenuDisplay": "ApproveBL",
                "subMenuOpen": false,
                "tableName": "Approve BL",
                "subMenuUrl": "go/approveBLList",
                "subSubMenus": []
            }
        ]
    },
    {
        "menuLabel": "Eq. Control",
        "menuIcon": <AllInbox />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Equipments",
                "subMenuDisplay": "Equipments",
                "subMenuOpen": false,
                "tableName": "Equipment and Movements",
                "subMenuUrl": "containerControl/equipmentAndMovementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Last Movement",
                "subMenuDisplay": "Last Movement",
                "subMenuOpen": false,
                "tableName": "Last Movement",
                "subMenuUrl": "containerControl/lastMovementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Range Movements",
                "subMenuDisplay": "Range Movements",
                "subMenuOpen": false,
                "tableName": "Last Movement",
                "subMenuUrl": "containerControl/rangeMovementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Demurrage Control",
                "subMenuDisplay": "Demurrage Control",
                "subMenuOpen": false,
                "tableName": "Demurrage Control",
                "subMenuUrl": "containerControl/demurrageControlList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Demurrage Mov.",
                "subMenuDisplay": "Demurrage Mov.",
                "subMenuOpen": false,
                "tableName": "Demurrage Control",
                "subMenuUrl": "containerControl/demurrageMovementList",
                "subSubMenus": []
            }
        ]
    },
	{
        "menuLabel": "Equipment",
        "menuIcon": <AccountBox />,
        "menuOpen": false,
        "tableName": "",
        "menuUrl": "",
        "subMenus": [
            {
                "subMenuLabel": "Eq. Type",
                "subMenuDisplay": "Equipment Type",
                "subMenuOpen": false,
                "tableName": "Equipment Type",
                "subMenuUrl": "containerControl/equipmentTypeList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Eq. Status",
                "subMenuDisplay": "Equipment Status",
                "subMenuOpen": false,
                "tableName": "Equipment Status",
                "subMenuUrl": "containerControl/equipmentStatusList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Eq. Class",
                "subMenuDisplay": "Equipment Class",
                "subMenuOpen": false,
                "tableName": "Equipment Class",
                "subMenuUrl": "containerControl/equipmentClassList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Eq. Service",
                "subMenuDisplay": "Equipment Service",
                "subMenuOpen": false,
                "tableName": "Equipment Service",
                "subMenuUrl": "containerControl/equipmentServiceList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Eq. Leasing",
                "subMenuDisplay": "Equipment Leasing",
                "subMenuOpen": false,
                "tableName": "Equipment Leasing",
                "subMenuUrl": "containerControl/equipmentLeasingList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Eq. Condition",
                "subMenuDisplay": "Equipment Condition",
                "subMenuOpen": false,
                "tableName": "Equipment Class",
                "subMenuUrl": "containerControl/equipmentConditionList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Mov.Type Eq.Status",
                "subMenuDisplay": "Movement Type Equipment Status",
                "subMenuOpen": false,
                "tableName": "Mov.Type Eq.Status",
                "subMenuUrl": "containerControl/movTypeEqStatusList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Movement Type",
                "subMenuDisplay": "Movement Type",
                "subMenuOpen": false,
                "tableName": "Movement Type",
                "subMenuUrl": "containerControl/movementTypeList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Sequence Mov.",
                "subMenuDisplay": "Sequence Movement",
                "subMenuOpen": false,
                "tableName": "Sequence Movement",
                "subMenuUrl": "containerControl/sequenceMovementList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Demurrage Rule",
                "subMenuDisplay": "Demurrage Rule",
                "subMenuOpen": false,
                "tableName": "Demurrage Rule",
                "subMenuUrl": "containerControl/demurrageRuleList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Transport",
                "subMenuDisplay": "Transport",
                "subMenuOpen": false,
                "tableName": "Transport",
                "subMenuUrl": "containerControl/transportList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Eq. Cost Rules",
                "subMenuDisplay": "Equipment Cost Rules",
                "subMenuOpen": false,
                "tableName": "Equipment Cost Rules",
                "subMenuUrl": "containerControl/equipmentCostRuleList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Eq. Cost Details",
                "subMenuDisplay": "Equipment Cost Details",
                "subMenuOpen": false,
                "tableName": "Equipment Cost Details",
                "subMenuUrl": "containerControl/equipmentCostDetailList",
                "subSubMenus": []
            },
            {
                "subMenuLabel": "Location Restriction",
                "subMenuDisplay": "Location Restriction",
                "subMenuOpen": false,
                "tableName": "Location Restriction",
                "subMenuUrl": "containerControl/locationRestrictionList",
                "subSubMenus": []
            },
        ]
    },
	{
        "menuLabel": "GenericEntity",
        "menuDisplay": "Generic Entity",
        "menuIcon": <ViewModule />,
        "tableName": "GENERICENTITY",
        "menuUrl": "",  // Vazio porque vai ter submenus
        "subMenus": []  // Será preenchido dinamicamente
    }

]